import React from 'react';
import { SectionHeading } from './SectionHeading';
import { bonuses } from '../data/content';
export function BonusSection() {
  return <section className="border-y-4 border-cream-deep bg-white px-4 py-6 sm:px-6" data-id="element-23" data-mp="1ofc3hoa8oheb">
      <SectionHeading size="lg" data-id="element-24" data-mp="22ebuh2l858dn">🎁 5 premium bonuses included</SectionHeading>

      <div className="mx-auto mt-4 max-w-2xl space-y-2.5" data-id="element-25" data-mp="1ydrxbz0ni4ri">
        {bonuses.map(bonus => <article key={bonus.number} className="rounded-md border-2 border-mustard/50 bg-cream p-3" data-id="element-26" data-mp="1anxixd0oo855">
            <p className="text-[10px] font-extrabold uppercase tracking-[0.14em] text-mustard" data-id="element-27" data-mp="15qxgrd6yfpjb">
              🎁 Bonus {bonus.number} — Free
            </p>
            <h3 className="mt-0.5 font-heading text-[14px] font-extrabold uppercase leading-tight text-navy sm:text-base" data-id="element-28" data-mp="1epit2qlu28bn">
              {bonus.title}
            </h3>

            {bonus.intro.map(line => <p key={line} className="mt-1.5 text-[12px] font-semibold leading-snug text-graphite sm:text-[13px]" data-id="element-29" data-mp="mzo26pibuakv">
                {line}
              </p>)}

            <p className="mt-2 text-[12px] font-medium leading-snug text-graphite sm:text-[13px]" data-id="element-30" data-mp="2epv1stnfwdpe">
              {bonus.listIntro}
            </p>

            <ul className="mt-1.5 flex flex-wrap gap-1" data-id="element-31" data-mp="2ogzgrtd47yk8">
              {bonus.items.map(item => <li key={item} className="rounded bg-white px-2 py-0.5 text-[11px] font-semibold text-navy" data-id="element-32" data-mp="1qtgzfu5e1o4m">
                  {item}
                </li>)}
            </ul>

            {bonus.after.map(line => <p key={line} className="mt-2 text-[12px] font-medium leading-snug text-graphite sm:text-[13px]" data-id="element-33" data-mp="20trdti35t1ld">
                {line}
              </p>)}

            <p className="mt-2 text-[12px] font-extrabold uppercase tracking-wide text-terracotta" data-id="element-34" data-mp="3h5ejbgf28oeo">
              {bonus.tag}
            </p>
          </article>)}
      </div>
    </section>;
}